import { ApiBase } from '@bymason/api-base';
import { CmsStartBuildingWidget } from './types';
import tempData from './temp-data';

export * from './types';

class CmsStartBuildingWidgetApi extends ApiBase {
  private static instance: CmsStartBuildingWidgetApi;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A CmsStartBuildingWidgetApi instance
   */
  public static getInstance(): CmsStartBuildingWidgetApi {
    if (!CmsStartBuildingWidgetApi.instance) {
      CmsStartBuildingWidgetApi.instance = new CmsStartBuildingWidgetApi();
    }

    return CmsStartBuildingWidgetApi.instance;
  }

  /**
   * Gets the start-building CMS content.
   * @returns a CmsStartBuilding model
   */
  public async getCmsStartBuildingContent() {
    //
    // TODO: Setup endpoint calls to get content from Strapi CMS
    //
    const dataResponse = await Promise.resolve<CmsStartBuildingWidget>(tempData);

    return dataResponse;
  }
}

export const startBuildingWidgetCmsApi = CmsStartBuildingWidgetApi.getInstance();
